// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { UIModelBaseElement } from './UIModelBaseElement';
import { EVOAction } from './EVOAction';
/**
 * 操作类型 实体类
 * 操作类型，定义操作的模板，自定义类型支持个性化
 */
export class ActionType extends UIModelBaseElement {
  /** 编码 : 有含义的字母编码，用于程序中使用，唯一 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 操作 */
  private _actions: Array<EVOAction>;

  /** 获取：操作 */
  public get actions() {
    return this._actions;
  }

  /** 设置：操作 */
  public set actions(value: Array<EVOAction>) {
    this._actions = value;
  }

  constructor() {
    super();
    this._code = '';
    this._actions = new Array<EVOAction>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ActionType, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.code = element.code;
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.code = json.Code;
    if (json.Actions && json.Actions.length > 0) {
      json.Actions.forEach((element: any) => {
        const eVOAction = EVOAction.Create(element);
        // eVOAction.actionType = this;
        this.actions.push(eVOAction);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Code = this.code;
    if (this.actions && this.actions.length > 0) {
      json.Actions = [];
      this.actions.forEach((element) => {
        json.Actions.push(element.toJson());
      });
    }
  }

  static Create(json: any): ActionType {
    const actionType = new ActionType();
    actionType.Deserialize(json);
    actionType.json = json;
    return actionType;
  }
}
